import { render } from "./PresentationBlock.vue?vue&type=template&id=3d37b41a&scoped=true"
const script = {}

import "./PresentationBlock.vue?vue&type=style&index=0&id=3d37b41a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d37b41a"]])

export default __exports__